import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, SelectChangeEvent, Tooltip } from '@mui/material';

interface SortComponentProps {
    setSortParams: React.Dispatch<React.SetStateAction<string>>;
    sortParams?:any,
    disabled: boolean,
}
const formControlStyle = {
    minWidth: 120,
    marginRight: 2,
    // height: '30px',
};
const inputLabelStyle = {
    jsuti: 'center',
    width: '100%',
    top: '-2px', 
    fontSize: '14px',
    
};

const selectStyle = {
    height: '40px', 
    lineHeight: '30px',
    padding: '0 8px',
    fontSize: '12px', 
};

function SortComponent(props:SortComponentProps){
    const {sortParams,setSortParams, disabled } = props;
    
    const handleSortChange = (event: SelectChangeEvent<string>) => {
        setSortParams(event?.target?.value.toString() ?? "default");
    };
    return (
        <Tooltip title={disabled ? "Sort cannot be applied with contains filter" : ""} arrow>
            <FormControl variant="outlined" style={formControlStyle}>
                <InputLabel style={inputLabelStyle}>Sort By</InputLabel>
                        <Select
                            value={sortParams}
                            defaultValue=""
                            onChange={handleSortChange}
                            label="Sort By"
                            style={selectStyle}
                            disabled={disabled}
                        >
                            <MenuItem value="default">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value="startDateDesc">Start Date (New to Old)</MenuItem>
                            <MenuItem value="startDateAsc">Start Date (Old to New)</MenuItem>
                            <MenuItem value="endDateDesc">End Date (New to Old)</MenuItem>
                            <MenuItem value="endDateAsc">End Date (Old to New)</MenuItem>
                            <MenuItem value="creationDateDesc">Creation Time (New to Old)</MenuItem>
                            <MenuItem value="creationDateAsc">Creation Time (Old to New)</MenuItem>
                        </Select>
            </FormControl>
        </Tooltip>
    );
}
export default SortComponent;
